import { next } from './utils';

export const navDropdown = () => {
    const mainNav = document.getElementById('sp-main-nav');
    const dropdownToggles = mainNav.querySelectorAll('li > a[href="#"]');

    function closeDropdown(el) {
        el.setAttribute('aria-hidden', 'true');
        el.classList.remove('show-menu');
    }

    function openDropdown(el) {
        el.setAttribute('aria-hidden', 'false');
        el.classList.add('show-menu');
    }

    function closeNav() {
        let openNav = mainNav.querySelector('.show-menu');
        if (openNav) {
            openNav.setAttribute('aria-hidden', 'true');
            openNav.classList.remove('show-menu');
        }
    }

    function leaveNav(event) {
        if (event.target.closest('#sp-main-nav')) return;
        closeNav();
    }

    dropdownToggles.forEach(function (toggle) {
        toggle.setAttribute('role', 'button');
        toggle.classList.add('sp-has-dropdown');
        const dropdown = next(toggle, 'ul');
        dropdown.dataset.sub = 'true';
        dropdown.setAttribute('aria-hidden', 'true');

        toggle.addEventListener('click', function (e) {
            e.preventDefault();

            if (window.matchMedia('(max-width: 767px)').matches) {
                closeNav();
                openDropdown(dropdown);
            }
        });

        if (window.matchMedia('(min-width: 768px)').matches) {
            toggle.addEventListener('mouseenter', function () {
                closeNav();
                openDropdown(dropdown);
            });

            toggle.addEventListener('mouseleave', function () {
                setTimeout(function () {
                    closeDropdown(dropdown);
                }, 250);
            });

            toggle.addEventListener('focus', function () {
                closeNav();
                openDropdown(dropdown);
            });
        }
    });

    document.body.addEventListener('click', leaveNav, false);
    document.body.addEventListener('focusin', leaveNav, false);
};
